export class GenerateRandomUtils {
  // Constants for reuse and clarity
  private static readonly LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  private static readonly NUMBERS = '0123456789';

  /**
   * Generates a random alphanumeric string with configurable lengths.
   * @param letterCount Number of random letters to include (default: 3)
   * @param numberCount Number of random digits to include (default: 2)
   * @returns A string containing random letters followed by random digits.
   */
  static generateRandomString(letterCount = 3, numberCount = 2): string {
    const getRandomChar = (source: string) =>
      source.charAt(Math.floor(Math.random() * source.length));

    // Validate inputs
    if (letterCount < 0 || numberCount < 0) {
      throw new Error('Counts must be non-negative integers.');
    }

    // Generate characters
    const randomLetters = Array.from({ length: letterCount }, () =>
      getRandomChar(GenerateRandomUtils.LETTERS)
    ).join('');
    const randomNumbers = Array.from({ length: numberCount }, () =>
      getRandomChar(GenerateRandomUtils.NUMBERS)
    ).join('');

    return `${randomLetters}${randomNumbers}`;
  }

  static getInitials(name: string = '') {
    if (!name) return '';
    const words = name?.trim()?.split(/\s+/);
    let initials = '';
    for (const word of words) {
      if (word.length > 0) {
        initials += word[0].toUpperCase();
      }
      if (initials.length === 2) {
        break;
      }
    }
    return initials;
  }
}
